import * as Actions from './fill-providers.actions';

const initialState = {
  fillProviders: [],
  error: null,
};

export const reduce = (state = initialState, action) => {
  const { fillProviders, error } = action;
  switch (action.type) {
    case Actions.GET_FILL_PROVIDERS_SUCCESS:
      return {
        ...state,
        fillProviders,
      };
    case Actions.GET_FILL_PROVIDERS_FAILURE:
      return {
        ...state,
        error,
      };
    default:
      return {
        ...state,
      };
  }
};

export { namespace } from './fill-providers.reducer.metadata';
